<script>
    import BlockGlobal from "./BlockGlobal.svelte";
    import {getCollapseClass} from '../../Common/tools';
    import {M} from "../../external";

    export let data, isCollapsable = false, isCollapsed = false;

    function toggleCollapse() {
        if (isCollapsable) {
            isCollapsed = !isCollapsed;
        }
    }
</script>
<div class="col20 f-left t-center mb-25 mt-15" on:click={toggleCollapse}><h4
        class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{M.SEPARATOR_WIDGET_NAME}</h4>
</div>
<BlockGlobal bind:data={data} isCollapsable={true} isCollapsed={true}/>